export default __webpack_public_path__ + "static/media/duppieCoin.84cdd6e4.svg";